module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "setBooks_box"
  }, [(_vm.showPage) ? _c('div', {
    staticClass: "setBooks"
  }, [_c('div', {
    staticClass: "header clear"
  }, [(_vm.service.length != 0) ? _c('form', {
    staticClass: "search",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.search($event)
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.keywords),
      expression: "keywords"
    }],
    staticClass: "field",
    attrs: {
      "type": "text",
      "placeholder": "搜索书籍"
    },
    domProps: {
      "value": (_vm.keywords)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.keywords = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    class: {
      'clearBtn': _vm.keywords.trim().length > 0
    },
    on: {
      "click": function($event) {
        _vm.clearInput($event)
      }
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../../static/new icon/search.png"),
      "alt": ""
    },
    on: {
      "click": function($event) {
        _vm.search($event)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.service.length != 0) ? _c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('div', {
    staticClass: "selectService"
  }, [_c('origin-select', {
    attrs: {
      "data": _vm.service,
      "selectObj": "service",
      "selectId": _vm.serviceId,
      "defValue": _vm.service.length === 1 ? '' : '全部服务'
    },
    on: {
      "selecter": _vm.selecter
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "selectGrads"
  }, [_c('origin-select', {
    attrs: {
      "data": _vm.grads,
      "selectObj": "grads",
      "selectId": _vm.gradId,
      "defValue": _vm.grads.length === 1 ? '' : '全部年级'
    },
    on: {
      "selecter": _vm.selecter
    }
  })], 1)]) : _vm._e()]), _vm._v(" "), _c('article', {
    ref: "viewBooks",
    staticClass: "book_list clear",
    on: {
      "scroll": function($event) {
        _vm.handleScroll()
      }
    }
  }, [_c('ul', {
    staticClass: "clear"
  }, _vm._l((_vm.catalog), function(item) {
    return _c('li', {
      key: item.id
    }, [_c('book', {
      attrs: {
        "booksData": item,
        "type": 1
      },
      on: {
        "setTop": _vm.setTop
      }
    })], 1)
  })), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "loading_books"
  }, [_c('div', {
    staticClass: "load_line"
  }), _vm._v(" "), _c('p', [_vm._v("正在加载中...")])]) : _vm._e()]), _vm._v(" "), (_vm.catalog.length == 0 && !_vm.isSearch && _vm.service.length != 0) ? _c('div', {
    staticClass: "noCatalog clear"
  }, [_c('img', {
    attrs: {
      "src": require("./../../assets/img/null.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("没有找到符合条件的书籍")])]) : _vm._e(), _vm._v(" "), (_vm.service.length == 0) ? _c('div', {
    staticClass: "noCatalog clear"
  }, [_c('img', {
    attrs: {
      "src": require("./../../assets/img/null.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("没有可以布置作业的书籍")]), _vm._v(" "), _c('p', [_vm._v("您可以联系\"教育顾问\"获取帮助")])]) : _vm._e(), _vm._v(" "), (_vm.catalog.length == 0 && _vm.pageIndex == 1 && _vm.isSearch) ? _c('div', {
    staticClass: "noResult clear"
  }, [_c('img', {
    attrs: {
      "src": require("./../../assets/img/null.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("没有找到符合条件的书籍")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "prev"
  }, [_c('button', {
    staticClass: "button",
    on: {
      "click": _vm.back
    }
  }, [_vm._v("上一步")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-97d01072","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/setWork/setBooks.vue
// module id = 1233
// module chunks = 1